export default __webpack_public_path__ + "confetti.ac94c7.png";